module.exports = __webpack_public_path__ + "img/bp.a939dc61.svg";